export const SINGLE_CHOICE = 'single_choice';
export const DROPDOWN = 'dropdown';
export const MULTIPLE_CHOICE = 'multiple_choice';
export const SINGLE_TEXTBOX = 'single_textbox';
export const COMMENT_BOX = 'comment_box';
export const STAR_RATING = 'star_rating';
export const SLIDER = 'slider';

export const QUESTION_TYPES = [
  { id: 1, value: SINGLE_CHOICE, text: 'Multiple choice' },
  { id: 2, value: DROPDOWN, text: 'Dropdown' },
  { id: 3, value: MULTIPLE_CHOICE, text: 'Checkboxes' },
  { id: 4, value: SINGLE_TEXTBOX, text: 'Single textbox' },
  { id: 5, value: COMMENT_BOX, text: 'Comment box' },
  { id: 6, value: STAR_RATING, text: 'Star rating' },
  { id: 7, value: SLIDER, text: 'Slider' },
];

export const MULTI_CHOICE_QUESTIONS = [SINGLE_CHOICE, DROPDOWN, MULTIPLE_CHOICE];
export const NON_MULTI_CHOICE_QUESTIONS = [SINGLE_TEXTBOX, COMMENT_BOX, STAR_RATING, SLIDER];
export const DEFAULT_POLL_QUESTION_TYPES = [SINGLE_CHOICE, DROPDOWN];

export const getQuestionTypes = (questionArray = []) => QUESTION_TYPES.filter(q => questionArray.includes(q.value));

export default QUESTION_TYPES;
